module.exports = __webpack_public_path__ + "img/pr-2.d5951086.png";